import '@fortawesome/fontawesome-free/css/all.min.css';
import React from "react"
import "./survey.scss";
import LayoutContainer from '../../components/Containers/LayoutContainer';
import PageHeader from '../../components/PageHeader/PageHeader';
import SurveyTable from './SurveyTable';
import { useNavigate } from 'react-router-dom';
import { PlusCircleFill } from 'react-bootstrap-icons';

const Survey: React.FunctionComponent = () => {
  const navigate = useNavigate()

  const handleAddSurveyBtn = ()=>{
    navigate("/survey/add")
  }

  const handleAddSurveyQuiz = ()=>{
    navigate("/survey/addQuiz")
  }

  const buttons = [
    {
      label: "Add Survey Quiz",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: handleAddSurveyQuiz,
    },
    {
      label: "Add Survey",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleAddSurveyBtn,
    },
  ];

    return (
      <LayoutContainer title="Survey">
        <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
         <h2>
          <i className="page-header-icon fa fa-home">
          </i>
          Survey
         </h2>
        <PageHeader buttons={buttons} />  
        </div>
        <div className="mx-2">
        <SurveyTable />
        </div>
      </LayoutContainer>
    );
  };
  

export default Survey;